var _path, _path2, _path3, _path4, _path5, _path6, _circle, _circle2, _path7, _path8, _circle3, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _circle4, _circle5, _circle6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashboardSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 131,
    viewBox: "0 0 140 131",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54 91H94",
    stroke: "#4D4D4D",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M54 101H94",
    stroke: "#4D4D4D",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M54 110H94",
    stroke: "#4D4D4D",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2 33H35",
    stroke: "#4D4D4D",
    strokeWidth: 4
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5 74.5V129",
    stroke: "#4D4D4D",
    strokeWidth: 4
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M100.308 83.934L101.722 82.5198L100.627 81.4245L99.2921 82.211L100.308 83.934ZM44.9084 17L46.4121 18.3188L49.3228 15H44.9084V17ZM106 89.6264H108V88.798L107.414 88.2122L106 89.6264ZM99.2921 82.211C93.0505 85.8893 85.7748 88 78 88V92C86.5084 92 94.4829 89.6881 101.323 85.657L99.2921 82.211ZM78 88C54.804 88 36 69.196 36 46H32C32 71.4051 52.5949 92 78 92V88ZM36 46C36 35.3945 39.9283 25.7114 46.4121 18.3188L43.4048 15.6812C36.3057 23.7755 32 34.3874 32 46H36ZM44.9084 15H3V19H44.9084V15ZM3 15C1.34314 15 0 16.3432 0 18H4C4 18.5523 3.55229 19 3 19V15ZM0 18V128H4V18H0ZM0 128C0 129.657 1.34314 131 3 131V127C3.55229 127 4 127.448 4 128H0ZM3 131H105V127H3V131ZM105 131C106.657 131 108 129.657 108 128H104C104 127.448 104.448 127 105 127V131ZM108 128V89.6264H104V128H108ZM98.8933 85.3482L104.586 91.0407L107.414 88.2122L101.722 82.5198L98.8933 85.3482Z",
    fill: "#4D4D4D"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 78,
    cy: 46,
    r: 44,
    stroke: "#4D4D4D",
    strokeWidth: 4
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 78,
    cy: 46,
    r: 36,
    stroke: "#4D4D4D",
    strokeWidth: 4
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M127.012 110.326L128.426 108.912L127.012 110.326ZM135.497 101.841L136.911 100.426L136.911 100.426L135.497 101.841ZM101.412 84.7258L99.9976 86.14L101.412 84.7258ZM109.215 77.0101L107.796 75.6006L109.215 77.0101ZM110.656 76.9994L109.242 78.4137L110.656 76.9994ZM107.796 75.6006C105.601 77.8102 103.162 79.7768 100.523 81.4567L102.671 84.831C105.561 82.9913 108.231 80.8382 110.634 78.4197L107.796 75.6006ZM128.426 108.912L102.826 83.3116L99.9976 86.14L125.598 111.74L128.426 108.912ZM134.083 108.912C132.521 110.474 129.988 110.474 128.426 108.912L125.598 111.74C128.722 114.864 133.787 114.864 136.911 111.74L134.083 108.912ZM134.083 103.255C135.645 104.817 135.645 107.35 134.083 108.912L136.911 111.74C140.036 108.616 140.036 103.551 136.911 100.426L134.083 103.255ZM109.242 78.4137L134.083 103.255L136.911 100.426L112.07 75.5852L109.242 78.4137ZM100.523 81.4567C98.9293 82.4712 98.6028 84.7452 99.9976 86.14L102.826 83.3116C103.299 83.7848 103.165 84.5164 102.671 84.831L100.523 81.4567ZM110.634 78.4197C110.271 78.7845 109.648 78.8199 109.242 78.4137L112.07 75.5852C110.868 74.3833 108.951 74.4375 107.796 75.6006L110.634 78.4197Z",
    fill: "#4D4D4D"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M49.2425 30.6306C49.4021 30.2519 49.7701 30 50.181 30H105.875C106.257 30 106.607 30.2179 106.773 30.5628C107.556 32.1942 108.31 33.9479 108.777 36.8813C108.872 37.474 108.405 38 107.805 38H48.1291C47.5289 38 47.0616 37.4737 47.1606 36.8817C47.6434 33.9957 48.4645 32.4767 49.2425 30.6306Z",
    fill: "#4D4D4D"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 59,
    cy: 46,
    r: 4,
    fill: "#F2463A",
    stroke: "#4D4D4D",
    strokeWidth: 2
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.9608 56.1181C67.2291 56.685 66.7557 57.2628 66.1285 57.2628H51.909C51.2818 57.2628 50.8084 56.685 51.0767 56.1181C52.2112 53.7218 55.3385 52 59.0187 52C62.699 52 65.8263 53.7218 66.9608 56.1181Z",
    fill: "#F2463A"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M66.9608 56.1181L66.0569 56.546L66.9608 56.1181ZM51.909 58.2628H66.1285V56.2628H51.909V58.2628ZM51.9806 56.546C52.8998 54.6044 55.593 53 59.0187 53V51C55.084 51 51.5227 52.8392 50.1729 55.6902L51.9806 56.546ZM59.0187 53C62.4445 53 65.1377 54.6044 66.0569 56.546L67.8646 55.6902C66.5148 52.8392 62.9534 51 59.0187 51V53ZM66.1285 58.2628C66.748 58.2628 67.3209 57.9775 67.6774 57.5071C68.0477 57.0186 68.1708 56.337 67.8646 55.6902L66.0569 56.546C66.0447 56.5203 66.0325 56.4723 66.0396 56.4142C66.0463 56.3599 66.0667 56.3211 66.0835 56.299C66.1136 56.2593 66.1362 56.2628 66.1285 56.2628V58.2628ZM51.909 56.2628C51.9013 56.2628 51.9239 56.2593 51.954 56.299C51.9708 56.3211 51.9912 56.3599 51.9979 56.4142C52.005 56.4723 51.9928 56.5203 51.9806 56.546L50.1729 55.6902C49.8667 56.337 49.9898 57.0186 50.3601 57.5071C50.7166 57.9775 51.2895 58.2628 51.909 58.2628V56.2628Z",
    fill: "#4D4D4D"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M75 46H99",
    stroke: "#4D4D4D",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M56 68H99",
    stroke: "#4D4D4D",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M75.5 54H90.5",
    stroke: "#4D4D4D",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M13 45H29",
    stroke: "#4D4D4D",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M13 54H29",
    stroke: "#4D4D4D",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M13 63H29",
    stroke: "#4D4D4D",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 45,
    r: 2,
    fill: "#4D4D4D"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 54,
    r: 2,
    fill: "#4D4D4D"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 63,
    r: 2,
    fill: "#4D4D4D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardSearch);
export default __webpack_public_path__ + "static/media/dashboard-search.2f476fd27ff30c48303e079fda52ef2a.svg";
export { ForwardRef as ReactComponent };